import { DiscoveryApi } from '@backstage/core-plugin-api';

export interface Release {
  id: string;
  date: string;
  displayDate: string;
  url: string;
  name: string;
  fileName: string;
}

interface ApiResponse<T = any> {
  status: string;
  message: string;
  result?: T;
}

export class ChangelogApiClient {
  private readonly discoveryApi: DiscoveryApi;
  private readonly serviceName = 'changelog';

  constructor(options: { discoveryApi: DiscoveryApi }) {
    this.discoveryApi = options.discoveryApi;
  }

  private async handleResponse<T>(response: Response): Promise<ApiResponse<T>> {
    if (!response.ok) {
      throw new Error(`API request failed: ${response.statusText}`);
    }
    const result = await response.json();
    return {
      status: result.status,
      message: result.message,
      result: result.result,
    };
  }

  async getReleases(limit?: number): Promise<Release[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl(this.serviceName);
    const queryParams = limit ? `?limit=${limit}` : '';
    const url = `${baseUrl}/releases${queryParams}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    const apiResponse = await this.handleResponse<Release[]>(response);

    if (apiResponse.status === 'error') {
      throw new Error(apiResponse.message || 'Failed to fetch releases');
    }

    return apiResponse.result || [];
  }

  async getMarkdownContent(fileUrl: string): Promise<string> {
    const response = await fetch(fileUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch markdown content: ${response.statusText}`);
    }

    return await response.text();
  }
}

